var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-b-70" }, [
    _vm.loading
      ? _c("div")
      : _c("div", [
          _c(
            "div",
            { staticClass: "shop" },
            [
              _c("div", { staticClass: "banner" }, [
                _c("img", { attrs: { src: _vm.bannerPic, alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-name", attrs: { id: "form" } }, [
                _vm._v("添加收货信息")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "90px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人", prop: "real_name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入姓名" },
                        model: {
                          value: _vm.form.real_name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "real_name", $$v)
                          },
                          expression: "form.real_name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入手机号" },
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", _vm._n($$v))
                          },
                          expression: "form.phone"
                        }
                      }),
                      _vm._v(" "),
                      _vm.showError
                        ? _c("div", { staticClass: "el-form-item__error" }, [
                            _vm._v(_vm._s(_vm.showText))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "验证码", prop: "verify_code" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "sms",
                          attrs: { placeholder: "请输入验证码" },
                          on: { input: _vm.handleSms },
                          model: {
                            value: _vm.form.verify_code,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "verify_code", $$v)
                            },
                            expression: "form.verify_code"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "suffix", disabled: _vm.timer },
                              on: { click: _vm.getCode },
                              slot: "suffix"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.timer
                                      ? _vm.count + "秒后重新获取"
                                      : "获取验证码"
                                  )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "address",
                      attrs: { label: "收货地址", prop: "address" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          placeholder:
                            "省份城市及详细街道、门牌号、小区、乡镇、村等"
                        },
                        model: {
                          value: _vm.form.address,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请复制购买平台的订单号，马上兑换"
                        },
                        model: {
                          value: _vm.form.platform_order_no,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "platform_order_no", $$v)
                          },
                          expression: "form.platform_order_no"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cbtn", on: { click: _vm.submitForm } },
                [_c("div", { staticClass: "text" }, [_vm._v("提交")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail" },
                _vm._l(_vm.imagesList, function(item, index) {
                  return _c("img", {
                    key: index,
                    staticClass: "lazy",
                    attrs: {
                      "data-src": item,
                      src: require("./../../assets/images/lazy.jpg"),
                      alt: ""
                    }
                  })
                }),
                0
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer", on: { click: _vm.submitForm } }, [
            _c("div", { staticClass: "name" }, [_vm._v("赶紧填写专属信息")]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]),
    _vm._v(" "),
    _vm.actOver !== ""
      ? _c("div", { staticClass: "mask" }, [
          _c("div", { staticClass: "panel" }, [
            _c("div", { staticClass: "over" }, [_vm._v(_vm._s(_vm.actOver))])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("div", { staticClass: "breathe" }, [_vm._v("赢好礼")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a40dda8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a40dda8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/free.vue
// module id = b4P8
// module chunks = 1